import { render } from "./CourseSurveys.vue?vue&type=template&id=d5baf4a4&scoped=true"
import script from "./CourseSurveys.vue?vue&type=script&lang=js"
export * from "./CourseSurveys.vue?vue&type=script&lang=js"

import "./CourseSurveys.vue?vue&type=style&index=0&id=d5baf4a4&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5baf4a4"]])

export default __exports__